import { DotLottie } from '@lottiefiles/dotlottie-web';
import { FadeSlider } from '../classes/FadeSlider';

document.addEventListener('DOMContentLoaded', () => {
	const roots = document.querySelectorAll('.stage');

	roots.forEach((root) => {
		new FadeSlider(root as HTMLElement, {
			autoplay: true,
			pagination: true,
		});

		const pauseBtn = root.querySelector<HTMLButtonElement>('.js-pause-button');
		const labelEl = root.querySelector<HTMLElement>('.pause-button__label');
		const iconEl = pauseBtn?.querySelector<HTMLElement>('.icn');
		const videoEl = root.querySelector<HTMLVideoElement>('video');

		if (!pauseBtn || !labelEl || !iconEl || !videoEl) {
			return;
		}

		const syncUI = (paused: boolean) => {
			if (paused) {
				pauseBtn.classList.add('is-paused');
				pauseBtn.setAttribute('aria-pressed', 'true');
				pauseBtn.setAttribute('aria-label', 'Abspielen');
				labelEl.textContent = 'Video abspielen';
				iconEl.classList.remove('icn--pause');
				iconEl.classList.add('icn--play');
			} else {
				pauseBtn.classList.remove('is-paused');
				pauseBtn.setAttribute('aria-pressed', 'false');
				pauseBtn.setAttribute('aria-label', 'Pause');
				labelEl.textContent = 'Video anhalten';
				iconEl.classList.remove('icn--play');
				iconEl.classList.add('icn--pause');
			}
		};

		syncUI(videoEl.paused);

		pauseBtn.addEventListener('click', () => {
			if (videoEl.paused) {
				videoEl.play();
				syncUI(false);
			} else {
				videoEl.pause();
				syncUI(true);
			}
		});
	});

	const stageLotties = document.querySelectorAll<HTMLCanvasElement>('.stage__lottiefile');
	if (stageLotties.length === 0) {
		return;
	}

	stageLotties.forEach((stageLottie) => {
		try {
			new DotLottie({
				canvas: stageLottie,
				src: '/assets/lottiefiles/Straehle_Blatt_Complete.json',
				autoplay: true,
			});
		} catch {
			// empty
		}
	});
});
